export default function ProfileSkeleton() {
  return (
    <div className="h-full flex-1 overflow-auto bg-btnBgColor px-3 pt-4 lg:px-5">
      <div className="min-h-screen">
        <div className="mx-auto animate-pulse rounded-lg bg-white shadow-sm">
          <div className="p-2 lg:p-6">
            <div className="rounded-lg bg-white p-2 lg:p-6">
              <div className="mb-4 flex flex-col items-center justify-between lg:mb-14 lg:flex-row">
                <div className="mr-auto flex items-center justify-start gap-4">
                  <div className="h-24 w-24 rounded-full bg-neutralExtraLight lg:h-32 lg:w-32" />
                  <div className="flex flex-col gap-2">
                    <div className="h-5 w-40 rounded bg-neutralLight" />
                    <div className="h-4 w-24 rounded bg-neutralLight" />
                  </div>
                </div>
                <div className="ml-auto h-10 w-28 rounded-lg bg-neutralLight" />
              </div>

              <div className="space-y-3 lg:space-y-6">
                {Array.from({ length: 4 }, (_, index) => (
                  <div
                    key={index}
                    className="flex justify-between border-b pb-2"
                  >
                    <div className="h-4 w-1/4 rounded bg-neutralLight" />
                    <div className="h-4 w-1/3 rounded bg-neutralLight" />
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
